import {
	GET_USER_SUCCESS,
	POST_USER_SUCCESS,
	GET_LAUNCH_INFO_SUCCESS,
} from 'stash/actions/api';

const profileReducer = (state = {}, action) => {
	switch (action.type) {
		case POST_USER_SUCCESS:
		case GET_USER_SUCCESS:
		case GET_LAUNCH_INFO_SUCCESS:
			return action.response.profile;
		default:
			return state;
	}
};

export default profileReducer;
